export type CountryDial = {
  code: string;        // ISO 3166-1 alpha-2
  name: string;        // Display name (English)
  dialCode: string;    // +XX
  validLengths: number[]; // Allowed national significant number lengths
};

export const COUNTRIES: CountryDial[] = [
  { code: 'PL', name: 'Poland', dialCode: '+48', validLengths: [9] },
  { code: 'UA', name: 'Ukraine', dialCode: '+380', validLengths: [9] },
  { code: 'RU', name: 'Russia', dialCode: '+7', validLengths: [10] },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44', validLengths: [10] },
  { code: 'US', name: 'United States', dialCode: '+1', validLengths: [10] },
  { code: 'CA', name: 'Canada', dialCode: '+1', validLengths: [10] },
  { code: 'DE', name: 'Germany', dialCode: '+49', validLengths: [10, 11] },
  { code: 'FR', name: 'France', dialCode: '+33', validLengths: [9] },
  { code: 'ES', name: 'Spain', dialCode: '+34', validLengths: [9] },
  { code: 'IT', name: 'Italy', dialCode: '+39', validLengths: [9, 10] },
  { code: 'PT', name: 'Portugal', dialCode: '+351', validLengths: [9] },
  { code: 'NL', name: 'Netherlands', dialCode: '+31', validLengths: [9] },
  { code: 'BE', name: 'Belgium', dialCode: '+32', validLengths: [9] },
  { code: 'SE', name: 'Sweden', dialCode: '+46', validLengths: [9, 10] },
  { code: 'NO', name: 'Norway', dialCode: '+47', validLengths: [8] },
  { code: 'DK', name: 'Denmark', dialCode: '+45', validLengths: [8] },
  { code: 'FI', name: 'Finland', dialCode: '+358', validLengths: [9, 10] },
  { code: 'IE', name: 'Ireland', dialCode: '+353', validLengths: [9] },
  { code: 'CH', name: 'Switzerland', dialCode: '+41', validLengths: [9] },
  { code: 'AT', name: 'Austria', dialCode: '+43', validLengths: [10, 11] },
  { code: 'CZ', name: 'Czechia', dialCode: '+420', validLengths: [9] },
  { code: 'SK', name: 'Slovakia', dialCode: '+421', validLengths: [9] },
  { code: 'HU', name: 'Hungary', dialCode: '+36', validLengths: [9] },
  { code: 'RO', name: 'Romania', dialCode: '+40', validLengths: [9] },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', validLengths: [8, 9] },
  { code: 'GR', name: 'Greece', dialCode: '+30', validLengths: [10] },
  { code: 'TR', name: 'Turkey', dialCode: '+90', validLengths: [10] },
  { code: 'LT', name: 'Lithuania', dialCode: '+370', validLengths: [8] },
  { code: 'LV', name: 'Latvia', dialCode: '+371', validLengths: [8] },
  { code: 'EE', name: 'Estonia', dialCode: '+372', validLengths: [7, 8] },
  { code: 'IS', name: 'Iceland', dialCode: '+354', validLengths: [7] },
  { code: 'AU', name: 'Australia', dialCode: '+61', validLengths: [9] },
  { code: 'NZ', name: 'New Zealand', dialCode: '+64', validLengths: [8, 9] },
  { code: 'BR', name: 'Brazil', dialCode: '+55', validLengths: [10, 11] },
  { code: 'AR', name: 'Argentina', dialCode: '+54', validLengths: [10] },
  { code: 'CL', name: 'Chile', dialCode: '+56', validLengths: [9] },
  { code: 'MX', name: 'Mexico', dialCode: '+52', validLengths: [10] },
  { code: 'CO', name: 'Colombia', dialCode: '+57', validLengths: [10] },
  { code: 'PE', name: 'Peru', dialCode: '+51', validLengths: [9] },
  { code: 'ZA', name: 'South Africa', dialCode: '+27', validLengths: [9] },
  { code: 'EG', name: 'Egypt', dialCode: '+20', validLengths: [9, 10] },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', validLengths: [10] },
  { code: 'KE', name: 'Kenya', dialCode: '+254', validLengths: [9] },
  { code: 'IN', name: 'India', dialCode: '+91', validLengths: [10] },
  { code: 'PK', name: 'Pakistan', dialCode: '+92', validLengths: [10] },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', validLengths: [10] },
  { code: 'CN', name: 'China', dialCode: '+86', validLengths: [11] },
  { code: 'JP', name: 'Japan', dialCode: '+81', validLengths: [10] },
  { code: 'KR', name: 'South Korea', dialCode: '+82', validLengths: [9, 10] },
  { code: 'SA', name: 'Saudi Arabia', dialCode: '+966', validLengths: [9] },
  { code: 'AE', name: 'United Arab Emirates', dialCode: '+971', validLengths: [9] }
];

export default COUNTRIES;
